import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value"];
import React, { useMemo } from 'react';
import MaskedInput from 'react-text-mask';
import { ECountry } from '@lumahealthhq/ui-model-types';
import { jsx as _jsx } from "react/jsx-runtime";
const masks = {
  default: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  [ECountry.US]: ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  [ECountry.Brazil]: ['+', '5', '5', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
};

/**
 * @ignore - internal component.
 */
const MaskedInputPhone = /*#__PURE__*/React.forwardRef((_ref, inputRef) => {
  let {
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const mask = useMemo(() => {
    const phoneNumber = value || '';
    if (phoneNumber.indexOf('+1') === 0) {
      return masks[ECountry.US];
    }
    if (phoneNumber.indexOf('+55') === 0) {
      return masks[ECountry.Brazil];
    }
    return masks.default;
  }, [value]);
  return /*#__PURE__*/_jsx(MaskedInput, _extends({
    ref: ref => inputRef && inputRef(ref ? ref.inputElement : null),
    value: value
  }, rest, {
    mask: mask,
    placeholder: "(000) 000-0000",
    inputMode: "numeric"
  }));
});
export default MaskedInputPhone;